import {
  calculateForeground,
  lightenDarkenColor,
  WebsiteConfigBM,
} from '@bm-js/atlascloud-shared'

export const updateColorCssVars = (websiteConfig: WebsiteConfigBM) => {
  if (!websiteConfig?.colors?.base) return
  const root = document.querySelector(':root') as HTMLElement
  if (!root) return
  const { base, accent } = websiteConfig.colors
  root.style.setProperty('--customer-primary-400', base)
  root.style.setProperty('--customer-primary-300', lightenDarkenColor(base, 30))
  root.style.setProperty('--customer-primary-200', lightenDarkenColor(base, 40))
  root.style.setProperty('--customer-primary-100', lightenDarkenColor(base, 50))
  root.style.setProperty('--customer-inverse', calculateForeground(base))

  if (!accent) return
  root.style.setProperty('--customer-accent-400', accent)
  root.style.setProperty(
    '--customer-accent-300',
    lightenDarkenColor(accent, 30)
  )
  root.style.setProperty(
    '--customer-accent-200',
    lightenDarkenColor(accent, 40)
  )
  root.style.setProperty(
    '--customer-accent-100',
    lightenDarkenColor(accent, 50)
  )
  root.style.setProperty(
    '--customer-accent-inverse',
    calculateForeground(accent)
  )
}
